<template>
  <div class="">
    <v-menu
      min-width="280"
      open-on-hover
      :close-on-content-click="false"
      allow-overflow
      close-delay="60"
      h-100
      ma-0
      pa-0
      :content-class="contentClass"
    >
      <template v-slot:activator="{ on, attrs }">
        <div class="w-100" v-bind="attrs" v-on="on">
          <inline-svg
            class="menu-svg"
            :class="{
              'custom-opacity':
                item.name !== $store.getters.getPreviousSelectedMenu,
            }"
            :src="item.svg"
          />
        </div>
      </template>
      <v-card class="elevation-0 h-100 poppins">
        <v-card-text
          style="color: black; font-weight: bold; line-height: 1.4"
          class="h3 uppercase pt-8 pe-0 text-black text-bold mb-0"
          :class="{ 'text-start ps-2': $vuetify.rtl }"
        >
          {{ $t(item.title) }}
        </v-card-text>

        <v-card-text class="ma-0 pa-0 poppins">
          <v-list v-if="item.type === 'default'">
            <template v-for="(val, index) in item.entities">
              <template v-if="!val.hasOwnProperty('items')">
                <v-list-item :key="index" v-if="isAvailableForUser(val)">
                  <div>
                    <router-link :to="{ name: val.name }">
                      <span
                        class="ma-0 pa-0 font-size-h5 font-weight-bolder text-dark-50 text-hover-dark uppercase poppins"
                        :class="{ 'text-start ps-2': $vuetify.rtl }"
                      >
                        {{ $t(val.title) }}
                      </span>
                    </router-link>
                  </div>
                </v-list-item>
              </template>

              <v-list-group :key="index" v-else no-action class="px-0">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title
                      v-text="$t(val.title)"
                      class="font-size-h5 font-weight-bolder text-dark-50 uppercase poppins"
                      :class="{ 'text-start ps-2': $vuetify.rtl }"
                    />
                  </v-list-item-content>
                </template>

                <template v-for="child in val.items">
                  <v-list-item
                    v-if="isAvailableForUser(child)"
                    :key="child.title"
                    :to="{ name: child.name }"
                    exact
                    class="cursor-pointer bg-hover-light-info ps-8"
                    :class="{ 'bg-light-info': activeSubmenu === child.name }"
                    @click="
                      () => {
                        $router.push({ name: child.name });
                        activeSubmenu = child.name;
                      }
                    "
                  >
                    <span
                      class="font-size-lg font-weight-medium text-dark-50 uppercase poppins"
                      :class="{
                        'text-start ps-2': $vuetify.rtl,
                        'text-start ps-2': !$vuetify.rtl,
                      }"
                    >
                      {{ $t(child.title) }}
                    </span>
                  </v-list-item>
                </template>
              </v-list-group>
            </template>
          </v-list>

          <v-list v-else>
            <template v-for="group in item.entities">
              <template v-if="group?.items">
                <!--                <v-list-group-->
                <!--                  v-if="isGroupShown(group?.items)"-->
                <!--                  :key="group.title"-->
                <!--                  no-action-->
                <!--                > -->
                <v-list-group :key="group.title" no-action>
                  <template v-slot:activator>
                    <v-list-item-content>
                      <div class="d-flex align-start">
                        <v-list-item-title
                          v-text="$t(group.title)"
                          class="font-size-h5 font-weight-bolder text-dark-50 text-hover-dark uppercase poppins"
                          :class="{ 'text-start': $vuetify.rtl }"
                        />
                        <span
                          v-if="isBetaItem(group.name)"
                          class="beta-sup-badge ms-1"
                        >
                          BETA
                        </span>
                      </div>
                    </v-list-item-content>
                  </template>

                  <template v-if="group?.items">
                    <template v-for="child in group.items">
                      <v-list-item
                        v-if="isAvailableForUser(child)"
                        :key="child.title"
                        :to="{ name: child.name }"
                        exact
                        class="cursor-pointer bg-hover-light-info"
                        :class="{
                          'bg-light-info': activeSubmenu === child.name,
                          'pe-4': $vuetify.rtl,
                          'ps-4': !$vuetify.rtl,
                        }"
                        @click="
                          () => {
                            $router.push({ name: child.name });
                            activeSubmenu = child.name;
                          }
                        "
                      >
                        <span
                          class="font-size-lg font-weight-medium text-dark-50 uppercase poppins"
                          :class="{
                            'text-start ps-2': $vuetify.rtl,
                            'text-start ps-2': !$vuetify.rtl,
                          }"
                        >
                          {{ $t(child.title) }}
                          <span
                            v-if="isBetaItem(child.name)"
                            class="beta-sup-badge ms-1"
                          >
                            BETA
                          </span>
                        </span>
                      </v-list-item>
                    </template>
                  </template>
                </v-list-group>
              </template>

              <template v-else>
                <v-list-item
                  v-if="isAvailableForUser(group)"
                  :key="'single-' + group.title"
                  :to="{ name: group.name }"
                  exact
                  class="cursor-pointer bg-hover-light-info"
                  :class="{ 'bg-light-info': activeSubmenu === group.name }"
                  @click="
                    () => {
                      $router.push({ name: group.name });
                      activeSubmenu = group.name;
                    }
                  "
                >
                  <v-list-item-content>
                    <span
                      class="ma-0 pa-0 font-size-h5 font-weight-bolder text-dark-50 text-hover-dark uppercase poppins"
                      :class="{ 'text-start ps-2': $vuetify.rtl }"
                    >
                      {{ $t(group.title) }}

                      <span
                        v-if="isBetaItem(group.name)"
                        class="beta-sup-badge ms-1"
                      >
                        BETA
                      </span>
                    </span>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </template>
          </v-list>
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SidebarMain",
  props: ["item"],
  data: () => ({
    activeSubmenu: null,
    betaItems: ["dashboard.dashboardAnalyticsBeta"],
  }),
  computed: {
    ...mapGetters(["isClient", "isPlusUser"]),

    contentClass: function () {
      const shadow = this.$vuetify.rtl ? "aside-shadow-rtl" : "aside-shadow";
      return `${shadow + " overflow-auto"}`;
    },
    hasPlusAccess() {
      if (this.isClient && this.isPlusUser) {
        return true;
      } else if (this.isClient && !this.isPlusUser) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    isBetaItem(name) {
      return this.betaItems.includes(name);
    },
    isAvailableForUser(child) {
      if (!this.isClient) {
        return true;
      }
      if (this.hasPlusAccess && child.premium) {
        return true;
      }
      if (this.hasPlusAccess && !child.premium) {
        return true;
      }
      if (!this.hasPlusAccess && child.premium) {
        return false;
      }
      if (!this.hasPlusAccess && !child.premium) {
        return true;
      }

      return false;
    },
    // isGroupShown(groupItems) {
    //   if (!this.isClient) {
    //     return true;
    //   }
    //   if (!groupItems) {
    //     return false;
    //   }
    //   if (groupItems?.length === 1) {
    //     return this.isAvailableForUser(groupItems[0]);
    //   } else return true;
    // },
  },
};
</script>

<style scoped>
.aside-shadow {
  position: fixed !important;
  top: 0px !important;
  height: 100vh !important;
  inset-inline-start: 70px !important;
  overflow-y: hidden;
  width: 260px;
  z-index: 6;
  /* background-color: transparent; */
  box-shadow: 8px 0 25px -8px rgba(138, 0, 138, 0.4),
    -12px 0 8px -4px rgba(255, 255, 255, 0);
  -webkit-box-shadow: 8px 0 25px -8px rgba(138, 0, 138, 0.4),
    -12px 0 8px -4px rgba(255, 255, 255, 0);
  -moz-box-shadow: 8px 0 25px -8px rgba(138, 0, 138, 0.4),
    -12px 0 8px -4px rgba(255, 255, 255, 0);
}
.aside-shadow-rtl {
  position: fixed !important;
  top: 0px !important;
  height: 100vh !important;
  inset-inline-start: 70px !important;
  overflow-y: hidden;
  width: 260px;
  z-index: 6;
  box-shadow: -2px 0 25px 2px rgba(138, 0, 138, 0.4),
    12px 0 8px 4px rgba(255, 255, 255, 0);
  -webkit-box-shadow: -2px 0 25px 2px rgba(138, 0, 138, 0.4),
    12px 0 8px 4px rgba(255, 255, 255, 0);
  -moz-box-shadow: -2px 0 25px 2px rgba(138, 0, 138, 0.4),
    12px 0 8px 4px rgba(255, 255, 255, 0);
}

.custom-opacity {
  filter: grayscale(100%) opacity(35%);
}

.beta-sup-badge {
  font-size: 9px;
  font-weight: 800;
  color: #fff;
  background: linear-gradient(135deg, #7322b0, #c32c80);
  padding: 2px 6px;
  border-radius: 8px;
  line-height: 1;
  margin-top: 0px;
  letter-spacing: 0.5px;
  box-shadow: 0 1px 4px rgba(195, 44, 128, 0.4);
}

svg {
  width: 100%;
}
.menu-svg {
  z-index: 12;
  width: 28px;
  padding: 13px 0;
  height: auto;
}
.menu-svg:hover,
.menu-svg[aria-expanded="true"] {
  cursor: pointer;
  filter: grayscale(0%) opacity(100%);
}
</style>
